import { Schema } from "@schema-types/types";

export function getFirstStepDisplayIdFromPipeline(journey: Schema.JourneySchema): string | null {
  if (!journey.stepPipeline || journey.stepPipeline.length === 0) {
    return journey.steps[0]?.displayId ?? journey.steps[0]?.id ?? null;
  }

  const firstPipe = journey.stepPipeline[0];
  if (firstPipe.type === Schema.PipeType.Start) {
    const directJunction = firstPipe.junctions?.find((j) => j.type === Schema.JunctionType.Direct);
    if (!directJunction) return journey.steps[0]?.displayId ?? journey.steps[0]?.id ?? null;
    const nextPipe = journey.stepPipeline.find((p) => p.id === directJunction.targetPipeId);
    if (nextPipe && "targetId" in nextPipe) return (nextPipe as Schema.StandardPipe).targetId;
    return journey.steps[0]?.displayId ?? journey.steps[0]?.id ?? null;
  }

  for (const pipe of journey.stepPipeline) {
    if (pipe.type === Schema.PipeType.Standard) {
      return (pipe as Schema.StandardPipe).targetId;
    }
  }

  return journey.steps[0]?.displayId ?? journey.steps[0]?.id ?? null;
}

export function getFirstStepFromPipeline(journey: Schema.JourneySchema): Schema.StepSchema | null {
  const firstStepDisplayId = getFirstStepDisplayIdFromPipeline(journey);
  if (!firstStepDisplayId) return null;
  return journey.steps.find((s) => s.id === firstStepDisplayId || s.displayId === firstStepDisplayId) ?? null;
}

export function isFirstStepInPipeline(journey: Schema.JourneySchema, stepIdOrDisplayId: string): boolean {
  const firstStep = getFirstStepFromPipeline(journey);
  if (!firstStep) return false;
  const currentStep = journey.steps.find((s) => s.id === stepIdOrDisplayId || s.displayId === stepIdOrDisplayId);
  return currentStep != null && firstStep.id === currentStep.id;
}
